import React from 'react'

import { Col, Row } from 'antd'

import { PagedExpenses } from 'core/application/employeeDashboard/summary/reimbursementRequests/getExpenses'

import Card from '../../../common/components/dataDisplay/Card'
import { parseZoneFormat } from '../../../common/dateFormatters'
import { formatMoney } from '../../../common/moneyFormatter'
import ExpenseStatusLabel from '../ExpenseStatusLabel'
import MoreActions from '../reimbursementRequests/MoreActions'

import './styles.less'

type ReimbursementRequestCardProps = {
  reimbursementRequest: PagedExpenses
  translate: (key: string) => string
  onDeleteExpense: (expenseId: string) => void
  onViewFilesForExpense: (expenseId: string) => void
}

const ReimbursementRequestCardMobile: React.FC<ReimbursementRequestCardProps> = (props) => {
  return (
    <>
      {props.reimbursementRequest &&
        props.reimbursementRequest.items.length > 0 &&
        props.reimbursementRequest.items.map((item, index) => (
          <div className={'insurance-premium-col'}>
            <Card className="mb-16 reimbursement-card-display">
              <Row justify={'space-between'} className="mb-16">
                <Col>
                  <span>#{item.expenseNumber}</span>
                </Col>
                <Col>
                  <ExpenseStatusLabel expenseStatus={item.expenseStatus} key={index} />
                </Col>
              </Row>
              <Row className="mb-16">
                <Col span={24}>
                  <Row justify={'space-between'}>
                    <Col>
                      <h6 className="amount-display">{formatMoney(item.amount)}</h6>
                    </Col>
                    <Col>
                      <span className="date-display">{parseZoneFormat(item.purchasedDate)}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row justify="space-between">
                <Col>
                  <span className="provider-display">{item.serviceProvider}</span>
                </Col>
                <Col>
                  <MoreActions
                    expense={item}
                    onDelete={props.onDeleteExpense}
                    onViewFiles={props.onViewFilesForExpense}
                    translate={props.translate}
                  />
                </Col>
              </Row>
            </Card>
          </div>
        ))}
    </>
  )
}

export default ReimbursementRequestCardMobile
